module.exports = __webpack_public_path__ + "img/users-solid.af431f53.svg";